<svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M35.6188 0.997803L13.9405 22.6762L3.10159 11.8373L0.131592 14.8073L10.9705 25.6461L10.9705 25.6462L13.9405 28.615L38.5888 3.9678L35.6188 0.997803Z"
		fill="#63CE1C"
	/>
</svg>
